export default __webpack_public_path__ + "static/1001-3b557dd7513834d1d0dee3a179ae09dc.gif";